import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface Metadata {
  buildMajor: number;
  buildMinor: number;
  buildRevision: number;
  buildTag: string;
}
interface AppState {
  version: Metadata;
}

const initialState: AppState = {
  version: { buildMajor: 0, buildMinor: 0, buildRevision: 0, buildTag: "BETA" },
};

export const AppChange = createSlice({
  name: "device",
  initialState,
  reducers: {
    setVersion: (state, action: PayloadAction<Metadata>) => {
      state.version = action.payload;
    },
  },
});

export const { setVersion } = AppChange.actions;

export default AppChange.reducer;
